import { SchemaObject } from '../interfaces/data-mapper/schema-object';
import { SchemaWrapper } from '../interfaces/data-mapper/schema-wrapper';

export function GenerateSchema(
	body: any,
	arrayOnly: boolean,
	categoryLabel?: string
): SchemaObject {
	const schemaObject: SchemaObject = { index: 0, schema: { schemaItems: {} } };
	getObjectKeys(schemaObject.schema, body, 'record', arrayOnly, true, false, categoryLabel);
	return schemaObject;
}

function getObjectKeys(
	schema: SchemaWrapper,
	obj: any,
	path: string,
	arrayOnly: boolean,
	isRootItem = false,
	inArray = false,
	categoryLabel?: string
) {
	if (obj === undefined || obj === null) return;

	if (Array.isArray(obj)) {
		if (arrayOnly && inArray) {
			return;
		}
		addSchemaItem(schema, obj, path, true, arrayOnly, categoryLabel);
		getObjectKeys(schema, obj[0], path + '.0', arrayOnly, false, true, categoryLabel);
	} else if (typeof obj === 'object') {
		if (isRootItem && (!obj || Object.keys(obj).length === 0)) {
			return;
		}
		if (!isRootItem) {
			addSchemaItem(schema, obj, path, false, arrayOnly, categoryLabel);
		} else if (categoryLabel) {
			// Add the root category node itself as an expandable object
			schema.schemaItems[categoryLabel] = {
				path: categoryLabel,
				type: 'object',
				sampleValue: obj,
			};
		}
		for (const key in obj) {
			const currentObj = obj[key];
			getObjectKeys(schema, currentObj, `${path}.${key}`, arrayOnly, false, inArray, categoryLabel);
		}
	} else {
		addSchemaItem(schema, obj, path, false, arrayOnly, categoryLabel);
	}
}

function addSchemaItem(
	schema: SchemaWrapper,
	obj: any,
	path: string,
	isArray: boolean,
	arrayOnly: boolean,
	categoryLabel?: string
) {
	let sampleValue: any = '';
	let objType = '';

	if (isArray) {
		sampleValue = Object.values(obj).length > 0 ? [obj[0]] : [];
		objType = `${Object.values(obj).length > 0 ? typeof obj[0] : 'any'}[]`;
	} else {
		sampleValue = obj;
		objType = typeof obj;
	}

	path = path.replaceAll('.0', '').replaceAll('record.', '');

	if (arrayOnly && !isArray) {
		return;
	}
	if (!Object.hasOwn(schema.schemaItems, path)) {
		schema.schemaItems[categoryLabel ? `${categoryLabel}.${path}` : path] = {
			path: categoryLabel ? `${categoryLabel}.${path}` : path,
			type: objType,
			sampleValue,
		};
	}
}
